export default __webpack_public_path__ + "static/HKGrotesk-ExtraBold-4c543b3ec016c45dd6052e0dae664e9d.woff2";